import axiosInstance from "../common/axiosInstance";
import { useMutation, UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

export const PATHS = Object.freeze({
  GET_USER_INTERACTIONS: "/interactions/user-interactions",
  GET_INTERACTION_DETAILS: "/interactions/interaction-details",
  GET_CONVERSONATIONAL_INSIGHTS: "/interactions/conversation-insights",
  GET_ACTIVE_USERS_AND_PARTICIPANTS: "/active-users-and-participants",
  GET_SHARED_USERS: "/interactions/shared-users",
  POST_SHARED_INTERACTIONS: "/interactions/share-interactions",
  POST_REVOKE_INTERACTION_ACCESS: "/interactions/revoke-interaction-access",
  GET_INTERACTION_SLIDES: "/interactions/slides",
  GET_INTERACTION_NOTES: "/notes/p2p-interactions",
  GET_USER_INTERACTION_COUNT: "/interactions/user-interactions/count",
  GET_ABSTRACTIVE_INSIGHTS: "/interactions/abstractive-insights",
  GET_DOWNLOAD_WBR_REPORT: "/interactions/download-wbr-report",
  GET_GLOBAL_SEARCH_INTERACTIONS: "/interactions/global-search-interactions",
  GET_SHARE_URL: "/interactions/share-url",
  POST_ADHOC_INTERACTION_BOT: "/recall-bot/adhoc-meeting-with-bot",
  GET_FRAMEWORK_STAGES: "/interactions/framework-stages",
  GENERATE_TEMPLATE_BASED_EXTRACTION: "/interactions/generate-template-based-extraction",
  GET_TEMPLATE_BASED_EXTARCTION: "/interactions/template-based-extraction",
  POST_SHARE_INTERACTION_VIA_EMAIL: "/interactions/share-interaction-via-email",
  POST_ASSET_ANALYZE: "/interactions/asset/analyze",
  GET_OPPORTUNITY_FILTERS: "/interactions/opportunity-filters",
});

interface GetActiveUsersParams {
  interactionId?: string;
}
interface GetUserInteractionsParams {
  offset: number;
  limit: number;
  sortBy: string;
  sortOrder: string;
  isExternal?: boolean;
  userPorId?: string;
  interactionTitle?: string;
  overallSentiment?: string;
  isTeamInteraction?: boolean;
  employeePorId: string;
  startTime: string;
  endTime: string;
  isSupportAdditionalCols?: boolean;
  sharedWithMeInteractions?: boolean;
  sharedByMeInteractions?: boolean;
  ratingSource?: string;
  isTeamOnlyInteraction?: boolean;
  isOnlyInteraction?: boolean;
  searchValue?: string;
  abstractiveScore?: string;
  dateFilterType?: string;
  isIncludeMeInTeamInteraction?: boolean;
  impersonatingPorId?: string;
  accessLevel?: string | undefined;
  taggedAccountSubOrgId?: string[];
  taggedOpportunityId?: string[];
}

interface GetInteractionDetailsParams {
  interactionId: string;
  isTeamInteraction: boolean;
  sharedWithMe?: boolean;
  sharedByMe?: boolean;
  impersonatingPorId?: string | undefined;
  accessLevel?: string | undefined;
}

interface GetConversationInsightsParams {
  interactionId: string;
  groupId?: string;
  impersonatingPorId?: string | undefined;
  accessLevel?: string | undefined;
}

interface GetSharedUsersParams {
  interactionId: string;
  groupId?: string;
  impersonatingPorId?: string | undefined;
  accessLevel?: string | undefined;
}

interface PostSharedInteractionsParams {
  interactionIds: string[];
  sharedWithEmails: string[];
  shareWithAccount?: boolean;
  revokeForProfileOrgIds: string[];
  revokeForAll?: boolean;
}

interface PostRevokeInteractionAccessParams {
  interactionId: string;
  sharedWithProfileId?: string;
  revokeForAll?: boolean;
}

interface GetInteractionNotesParams {
  interactionId: string;
  impersonatingPorId?: string | undefined;
  accessLevel?: string | undefined;
}

interface GetUserInteractionCountParams {
  // offset: number;
  // limit: number;
  isExternal?: boolean;
  userPorId?: string;
  interactionTitle?: string;
  overallSentiment?: string;
  isTeamOnlyInteraction?: boolean;
  employeePorId: string;
  startTime: string;
  endTime: string;
  ratingSource?: string;
  isTeamInteraction?: boolean;
  isOnlyInteraction?: boolean;
  searchValue?: string;
  abstractiveScore?: string;
  impersonatingPorId?: string;
  accessLevel?: string | undefined;
  taggedAccountSubOrgId?: string[];
  taggedOpportunityId?: string[];
}

interface GetAbstractiveInsightsParams {
  interactionId: string;
  groupId?: string;
  impersonatingPorId?: string | undefined;
  accessLevel?: string | undefined;
}

interface GetGlobalSearchInteractionsParams {
  offset: number;
  limit: number;
  sortBy: string;
  sortOrder: string;
  employeePorId: string;
  startTime: string;
  endTime: string;
  searchEmail: string;
  searchProfileOrgId?: string;
}

interface PostAdhocInteractionBotParams {
  meetingUrl: string;
  profileOrgId: string;
  title: string;
  interactionId: string;
}
interface PostGenerateTemplateBasedExtractionParams {
  interactionId: string;
  interactionAssetId: string;
  framework: string;
  stageId: string;
  key: string;
};

interface GetGenerateTemplateBasedExtractionParams {
  interactionId: string;
  groupId?: string;
  keys: string;
  impersonatingPorId?: string | undefined;
  accessLevel?: string | undefined;
};

interface GetShareInteractionViaEmailParams {
  interactionId: string;
  sharedWithInternalEmails?: string[];
  sharedWithExternalEmails?: string[];
  revokeInternalProfileOrgRelationshipIds?: string[];
  revokeExternalEmails?: string[];
  sharedWithExternalDomain?: string;
  revokeExternalDomain?: string;
  tokenId: string;
  shareType?: string;
}

interface PostAssetAnalyzeParams {
  assetId: string;
  transcriptAnalysis: boolean;
  slideAnalysis: boolean;
}

export interface GetActiveOpportunitiesParams {
  impersonatingPorId?: string | undefined;
  accessLevel?: string | undefined;
}

const getUserInteractions = async (
  params: GetUserInteractionsParams
): Promise<any> => {
  const response = await axiosInstance.post(
    PATHS.GET_USER_INTERACTIONS,
    {
      userPorId: params.userPorId,
      ...(params.interactionTitle && {
        interactionTitle: params.interactionTitle,
      }),
      ...(params.overallSentiment && {
        overallSentiment: params.overallSentiment,
      }),
        isTeamInteraction: params.isTeamInteraction,
      isExternal: params.isExternal,
      employeePorId: params.employeePorId,
      startTime: params.startTime,
      endTime: params.endTime,
      isTeamOnlyInteraction: params.isTeamOnlyInteraction,
      isOnlyInteraction: params.isOnlyInteraction,
      ...(params.sharedWithMeInteractions && {
        sharedWithMeInteractions: params.sharedWithMeInteractions,
      }),
        ...(params.sharedByMeInteractions && {
    sharedByMeInteractions: params.sharedByMeInteractions,
    }),
    ...(params.ratingSource && {
      ratingSource: params.ratingSource,
    }),
    ...(params.searchValue && {
      searchValue: params.searchValue,
    }),
    ...(params.abstractiveScore && {
      abstractiveScore: params.abstractiveScore
    }),
    ...(params.dateFilterType && {
      dateFilterType: params.dateFilterType
    }),
    ...(params.isIncludeMeInTeamInteraction !== undefined && {
      isIncludeMeInTeamInteraction: params.isIncludeMeInTeamInteraction,
    }),
    ...(params.taggedAccountSubOrgId && {
      taggedAccountSubOrgId: params.taggedAccountSubOrgId,
    }),
    ...(params.taggedOpportunityId && {
      taggedOpportunityId: params.taggedOpportunityId,
    }),
    },
    {
      params: {
        offset: params.offset,
        limit: params.limit,
        sortBy: params.sortBy,
        sortOrder: params.sortOrder,
        ...(params.isSupportAdditionalCols && {
          isSupportAdditionalCols: params.isSupportAdditionalCols,
        }),
        impersonatingPorId: params.impersonatingPorId,
        accessLevel: params.accessLevel,
      },
    }
  );
  return response.data;
};

const useGetUserInteractions = (
  params: GetUserInteractionsParams,
  enabled: boolean
) => {
  const stringifiedParams = JSON.stringify(params);
  return useQuery<any>({
    queryKey: ["get_user_interactions", stringifiedParams],
    queryFn: () => getUserInteractions(params),
    enabled: enabled,
    retry: 0,
  });
};

const getInteractionDetails = async (
  params: GetInteractionDetailsParams
): Promise<any> => {
  const response = await axiosInstance.get(PATHS.GET_INTERACTION_DETAILS, {
    params: {
      interactionId: params.interactionId,
      isTeamInteraction: params.isTeamInteraction,
      ...(params.sharedWithMe &&{ sharedWithMe: params.sharedWithMe }),
      ...(params.sharedByMe && { sharedByMe: params.sharedByMe }),
      ...(params.impersonatingPorId && { impersonatingPorId: params.impersonatingPorId }),
      ...(params.accessLevel && { accessLevel: params.accessLevel }),
    },
  });
  return response.data;
};

const useGetInteractionDetails = (
  params: GetInteractionDetailsParams,
  enabled: boolean
) => {
  const stringifiedParams = JSON.stringify(params);
  return useQuery<any>({
    queryKey: ["get_interaction_details", stringifiedParams],
    queryFn: () => getInteractionDetails(params),
    enabled,
    retry: 0,
  });
};

const getConversationInsights = async (
  params: GetConversationInsightsParams
): Promise<any> => {
  const response = await axiosInstance.get(PATHS.GET_CONVERSONATIONAL_INSIGHTS, {
    params: {
      interactionId: params.interactionId,
      groupId: params.groupId,
      ...(params.impersonatingPorId && { impersonatingPorId: params.impersonatingPorId }),
      ...(params.accessLevel && { accessLevel: params.accessLevel }),
    },
  });
  return response;
};

const useGetConversationInsights = (
  params: GetConversationInsightsParams,
  enabled: boolean
) => {
  const stringifiedParams = JSON.stringify(params);
  return useQuery<any>({
    queryKey: ["get_conversation_insights", stringifiedParams],
    queryFn: () => getConversationInsights(params),
    enabled,
    retry: 0,
  });
};

const getActiveUsers = async (params: GetActiveUsersParams): Promise<any> => {
  const response = await axiosInstance.get(PATHS.GET_ACTIVE_USERS_AND_PARTICIPANTS,{
    params: {
      ...(params.interactionId && { interactionId: params.interactionId }),
    }
  });
  return response;
};

const useGetActiveUsers = (
  params: GetActiveUsersParams,
  enabled: boolean
): UseQueryResult<any, any> => {
  const stringifiedParams = JSON.stringify(params);
  return useQuery({
    queryKey: ["get_active_users", stringifiedParams],
    queryFn: () => getActiveUsers(params),
    enabled,
    retry: 0,
  });
};

const getSharedUsers = async (
  params: GetSharedUsersParams
): Promise<any> => {
  const response = await axiosInstance.get(PATHS.GET_SHARED_USERS, {
    params: {
      interactionId: params.interactionId,
    },
  });
  return response;
};

const useGetSharedUsers = (
  params: GetSharedUsersParams,
  enabled: boolean
): UseQueryResult<any, any> => {
  const stringifiedParams = JSON.stringify(params);
  return useQuery({
    queryKey: ["get_shared_users", stringifiedParams],
    queryFn: () => getSharedUsers(params),
    enabled,
    retry: 0,
  });
};

const postSharedInteractions = async (
  params: PostSharedInteractionsParams
): Promise<any> => {
  const { interactionIds, sharedWithEmails, shareWithAccount, revokeForProfileOrgIds, revokeForAll } = params;

  const response = await axiosInstance.post(
    PATHS.POST_SHARED_INTERACTIONS,
    null,
    {
      params: {
        interactionIds: interactionIds.join(','),
        sharedWithEmails: sharedWithEmails.join(','),
        ...(shareWithAccount !== undefined && {
          shareWithAccount,
        }),
        ...(revokeForAll
          ? { revokeForAll }
          : revokeForProfileOrgIds?.length
            ? { revokeForProfileOrgIds: revokeForProfileOrgIds.join(',') }
            : {}),
      },
    }
  );

  return response;
};

const usePostSharedInteractions = (): UseMutationResult<
  any,
  unknown,
  PostSharedInteractionsParams
> => {
  return useMutation({
    mutationKey: ["post_shared_interactions"],
    mutationFn: postSharedInteractions,
  });
};

const postRevokeInteractionAccess = async (
  params: PostRevokeInteractionAccessParams
): Promise<any> => {
  const { interactionId, sharedWithProfileId, revokeForAll } = params;

  const response = await axiosInstance.post(
    PATHS.POST_REVOKE_INTERACTION_ACCESS,
    null, // No body, all data in query params
    {
      params: {
        interactionId,
        ...(sharedWithProfileId && { sharedWithProfileId }),
        ...(revokeForAll !== undefined && { revokeForAll }),
      },
    }
  );

  return response;
};

const usePostRevokeInteractionAccess = (): UseMutationResult<
  any,
  unknown,
  PostRevokeInteractionAccessParams
> => {
  return useMutation({
    mutationKey: ["post_revoke_interaction_access"],
    mutationFn: postRevokeInteractionAccess,
  });
};

const getInteractionSlides = async (
  params: GetSharedUsersParams
): Promise<any> => {
  const response = await axiosInstance.get(PATHS.GET_INTERACTION_SLIDES, {
    params: {
      interactionId: params.interactionId,
      groupId: params.groupId,
      ...(params.impersonatingPorId && { impersonatingPorId: params.impersonatingPorId }),
      ...(params.accessLevel && { accessLevel: params.accessLevel }),
    },
  });
  return response;
};

const useGetInteractionSlides = (
  params: GetSharedUsersParams,
  enabled: boolean
): UseQueryResult<any, any> => {
  const stringifiedParams = JSON.stringify(params);
  return useQuery({
    queryKey: ["get_interaction_slides", stringifiedParams],
    queryFn: () => getInteractionSlides(params),
    enabled,
    retry: 0,
  });
};

const getInteractionNotes = async (
  params: GetInteractionNotesParams
): Promise<any> => {
  const response = await axiosInstance.get(PATHS.GET_INTERACTION_NOTES, {
    params: {
      interactionId: params.interactionId,
      ...(params.impersonatingPorId && { impersonatingPorId: params.impersonatingPorId }),
      ...(params.accessLevel && { accessLevel: params.accessLevel }),
    },
  });
  return response.data;
};

const useGetInteractionNotes = (
  params: GetInteractionNotesParams,
  enabled: boolean
): UseQueryResult<any, any> => {
  const stringifiedParams = JSON.stringify(params);
  return useQuery({
    queryKey: ["get_interaction_notes", stringifiedParams],
    queryFn: () => getInteractionNotes(params),
    enabled,
    retry: 0,
  });
};

const getUserInteractionCount = async (
  params: GetUserInteractionCountParams
): Promise<any> => {
  const response = await axiosInstance.post(PATHS.GET_USER_INTERACTION_COUNT, 
    {
      userPorId: params.userPorId,
      ...(params.interactionTitle && {
        interactionTitle: params.interactionTitle,
      }),
      ...(params.overallSentiment && {
        overallSentiment: params.overallSentiment,
      }),
      isExternal: params.isExternal,
      employeePorId: params.employeePorId,
      startTime: params.startTime,
      endTime: params.endTime,
      isTeamInteraction: params.isTeamInteraction,
      isTeamOnlyInteraction: params.isTeamOnlyInteraction,
      isOnlyInteraction: params.isOnlyInteraction,
      ...(params.ratingSource && {
        ratingSource: params.ratingSource,
      }),
      ...(params.searchValue && {
        searchValue: params.searchValue,
      }),
      ...(params.abstractiveScore && {
        abstractiveScore: params.abstractiveScore,
      }),
      ...(params.taggedAccountSubOrgId && {
        taggedAccountSubOrgId: params.taggedAccountSubOrgId,
      }),
      ...(params.taggedOpportunityId && {
        taggedOpportunityId: params.taggedOpportunityId,
      }),
    },
    {
      params: {
        impersonatingPorId: params.impersonatingPorId,
        accessLevel: params.accessLevel,
      },
    }
  );
  return response.data;
}

const useGetUserInteractionCount = (
  params: GetUserInteractionCountParams,
  enabled: boolean,
): UseQueryResult<any, any> => {
  const stringifiedParams = JSON.stringify(params);
  return useQuery({
    queryKey: ["get_user_interactions_count", stringifiedParams],
    queryFn: () => getUserInteractionCount(params),
    enabled,
    retry: 0,
  });
};

const getAbstractiveInsights = async (
  params: GetAbstractiveInsightsParams
): Promise<any> => {
  const response = await axiosInstance.get(PATHS.GET_ABSTRACTIVE_INSIGHTS, {
    params: {
      interactionId: params.interactionId,
      groupId: params.groupId,
      ...(params.impersonatingPorId && { impersonatingPorId: params.impersonatingPorId }),
      ...(params.accessLevel && { accessLevel: params.accessLevel }),
    },
  });
  return response;
};

const useGetAbstractiveInsights = (
  params: GetAbstractiveInsightsParams,
  enabled: boolean
): UseQueryResult<any, any> => {
  const stringifiedParams = JSON.stringify(params);
  return useQuery({
    queryKey: ["get_abstractive_insights", stringifiedParams],
    queryFn: () => getAbstractiveInsights(params),
    enabled,
    retry: 0,
  });
};

const getWbrReport = async (department: string): Promise<Blob> => {
  const response = await axiosInstance.get(PATHS.GET_DOWNLOAD_WBR_REPORT, {
    params: { department },
    responseType: "blob",
  });
  return response.data;
};

const useDownloadWbrReport = (
  handlerFunctions: UseMutationOptions<Blob, any, string> = {}
): UseMutationResult<Blob, any, string> => {
  return useMutation({
    mutationKey: ["download_wbr_report"],
    mutationFn: (department: string) => getWbrReport(department),
    ...handlerFunctions,
  });
};
const getGlobalSearchInteractions = async (
  params: GetGlobalSearchInteractionsParams
): Promise<any> => {
  const response = await axiosInstance.post(
    PATHS.GET_GLOBAL_SEARCH_INTERACTIONS,
    {
      employeePorId: params.employeePorId,
      startTime: params.startTime,
      endTime: params.endTime,
      searchEmail: params.searchEmail,
      searchProfileOrgId: params.searchProfileOrgId,
    },
    {
      params: {
        offset: params.offset,
        limit: params.limit,
        sortBy: params.sortBy,
        sortOrder: params.sortOrder,
      },
    }
  );

  return response.data;
};

const useGetGlobalSearchInteractions = (
  params: GetGlobalSearchInteractionsParams,
  enabled: boolean
): UseQueryResult<any, any> => {
  const stringifiedParams = JSON.stringify(params);
  return useQuery({
    queryKey: ["get_global_search_interactions", stringifiedParams],
    queryFn: () => getGlobalSearchInteractions(params),
    enabled,
    retry: 0,
  });
};

const getShareUrl = async (
  params: GetActiveUsersParams
): Promise<any>=> {
  const response = await axiosInstance.get(
    PATHS.GET_SHARE_URL,{
      params: {
        interactionId: params.interactionId
      },
    }
  )
  return response;
};

const useGetShareUrl = (
  params: GetActiveUsersParams,
  enabled: boolean
): UseQueryResult<any, any> => {
  return useQuery({
    queryKey: ["get_share_url", params],
    queryFn: () => getShareUrl(params),
    enabled,
    retry: 0,
  });
}

const postShareUrl = async (
  params: GetActiveUsersParams
): Promise<any> => {
  const response = await axiosInstance.post(
    PATHS.GET_SHARE_URL,
    null, // no body
    {
      params: {
        interactionId: params.interactionId,
      },
    }
  );
  return response;
};

const usePostShareUrl = (): UseMutationResult<
  any,
  unknown,
  GetActiveUsersParams
> => {
  return useMutation({
    mutationKey: ["post_share_url"],
    mutationFn: postShareUrl,
  });
};

const postAdhocInteractionBot = async (
  params: PostAdhocInteractionBotParams
): Promise<any> => {
  const response = await axiosInstance.post(
    PATHS.POST_ADHOC_INTERACTION_BOT,
    null,
    {
      params: {
        meetingUrl: params.meetingUrl,
        profileOrgId: params.profileOrgId,
        title: params.title,
        interactionId: params.interactionId,
      },
    }
  );

  return response.data;
};

const usePostAdhocInteractionBot = (): UseMutationResult<
  any,
  unknown,
  PostAdhocInteractionBotParams
> => {
  return useMutation({
    mutationKey: ["post_adhoc_interaction_bot"],
    mutationFn: postAdhocInteractionBot,
  });
};

const getFrameworkStages = async(
): Promise<any> => {
  const response = await axiosInstance.get(PATHS.GET_FRAMEWORK_STAGES);
  return response.data;
}

const useGetFrameworkStages = (
  enabled: boolean
): UseQueryResult<any, any> => {
  return useQuery({
    queryKey: ["get_framework_stages"],
    queryFn: getFrameworkStages,
    enabled,
    retry: 0,
  });
}

const getActiveOpportunities = async (
  params?: GetActiveOpportunitiesParams
): Promise<any> => {
  const response = await axiosInstance.get(PATHS.GET_OPPORTUNITY_FILTERS, {
    params: {
      ...(params?.impersonatingPorId && { impersonatingPorId: params.impersonatingPorId }),
      ...(params?.accessLevel && { accessLevel: params.accessLevel }),
    },
  });
  return response;
};

const useGetActiveOpportunities = (
  enabled: boolean,
  params?: GetActiveOpportunitiesParams
): UseQueryResult<any, any> => {
  return useQuery({
    queryKey: [
      "get_active_opportunities",
      params?.impersonatingPorId,
      params?.accessLevel,
    ],
    queryFn: () => getActiveOpportunities(params),
    enabled,
    retry: 0,
  });
};

const PostGenerateTemplateBasedExtraction = async(
  params: PostGenerateTemplateBasedExtractionParams
): Promise<any> => {
  const response = await axiosInstance.post(PATHS.GENERATE_TEMPLATE_BASED_EXTRACTION, null,{
    params: {
      interactionId: params.interactionId,
      interactionAssetId: params.interactionAssetId,
      framework: params.framework,
      stageId: params.stageId,
      key: params.key,
    }
  });
  return response;
}

const usePostGenerateTemplateBasedExtraction = (): UseMutationResult<
  any,
  unknown,
  PostGenerateTemplateBasedExtractionParams
> => {
  return useMutation({
    mutationKey: ["post_generate_template_based_extraction"],
    mutationFn: PostGenerateTemplateBasedExtraction,
  });
}

export const fetchGenerateTemplateBasedExtraction = async(
  params: GetGenerateTemplateBasedExtractionParams
): Promise<any> => {
  const response = await axiosInstance.get(PATHS.GET_TEMPLATE_BASED_EXTARCTION,{
    params: {
      interactionId: params.interactionId,
      ...(params.groupId && {groupId: params.groupId}),
      keys: params.keys,
      ...(params.impersonatingPorId && { impersonatingPorId: params.impersonatingPorId }),
      ...(params.accessLevel && { accessLevel: params.accessLevel }),
    },
  });
  return response.data;
}

const useGetGenerateTemplateBasedExtraction = (
  params: GetGenerateTemplateBasedExtractionParams,
  enabled: boolean
): UseQueryResult<any, any> => {
  const stringifiedParams = JSON.stringify(params);
  return useQuery({
    queryKey: ["get_generate_template_based_extraction", stringifiedParams],
    queryFn: () => fetchGenerateTemplateBasedExtraction(params),
    enabled,
    retry: 0,
  });
}

const getShareInteractionViaEmail = async (
  params: GetShareInteractionViaEmailParams
): Promise<any> => {
  const response = await axiosInstance.post(PATHS.POST_SHARE_INTERACTION_VIA_EMAIL,{
    interactionId: params.interactionId,
    sharedWithInternalEmails: params.sharedWithInternalEmails,
    sharedWithExternalEmails: params.sharedWithExternalEmails,
    revokeInternalProfileOrgRelationshipIds: params.revokeInternalProfileOrgRelationshipIds,
    revokeExternalEmails: params.revokeExternalEmails,
    sharedWithExternalDomain: params.sharedWithExternalDomain,
    revokeExternalDomain: params.revokeExternalDomain,
    tokenId: params.tokenId,
    shareType: params.shareType,
  });
  return response;
};

const useShareInteractionViaEmail = (): UseMutationResult<
  any,
  unknown,
  GetShareInteractionViaEmailParams
> => {
  return useMutation({
    mutationKey: ["post_share_interaction_via_email"],
    mutationFn: getShareInteractionViaEmail,
  });
};

const postAssetAnalyze = async(
  params: PostAssetAnalyzeParams
): Promise<any> => {
  const response = await axiosInstance.post(PATHS.POST_ASSET_ANALYZE,{
    assetId: params.assetId,
    transcriptAnalysis: params.transcriptAnalysis,
    slideAnalysis: params.slideAnalysis,
  });
  return response;
}

const usePostAssetAnalyze = (): UseMutationResult<
  any, 
  unknown, 
  PostAssetAnalyzeParams
> => {
  return useMutation({
    mutationKey: ["post_asset_analyze"],
    mutationFn: postAssetAnalyze,
  });
};

export interface UserInteractionsService {
  readonly useGetUserInteractions: (
    params: GetUserInteractionsParams,
    enabled: boolean
  ) => UseQueryResult<any, any>;

  readonly useGetInteractionDetails: (
    params: GetInteractionDetailsParams,
    enabled: boolean
  ) => UseQueryResult<any, any>;

  readonly useGetConversationInsights: (
    params: GetConversationInsightsParams,
    enabled: boolean
  ) => UseQueryResult<any, any>;

  readonly useGetActiveUsers: (
    params: GetActiveUsersParams,
    enabled: boolean
  ) => UseQueryResult<any, any>;

  readonly useGetSharedUsers: (
    params: GetSharedUsersParams,
    enabled: boolean
  ) => UseQueryResult<any, any>;

  readonly usePostSharedInteractions: () => UseMutationResult<
    any,
    unknown,
    PostSharedInteractionsParams
  >;

  readonly usePostRevokeInteractionAccess: () => UseMutationResult<
  any,
  unknown,
  PostRevokeInteractionAccessParams
>;

readonly useGetInteractionSlides: (
  params: GetSharedUsersParams,
  enabled: boolean
) => UseQueryResult<any, any>;

readonly useGetInteractionNotes: (
  params: GetInteractionNotesParams,
  enabled: boolean
) => UseQueryResult<any, any>;

readonly useGetUserInteractionCount: (
  params: GetUserInteractionCountParams,
  enabled: boolean
) => UseQueryResult<any, any>;

readonly useGetAbstractiveInsights: (
  params: GetAbstractiveInsightsParams,
  enabled: boolean
) => UseQueryResult<any, any>;

readonly useDownloadWbrReport: (
  handlerFunctions?: UseMutationOptions<Blob, any, string>
) => UseMutationResult<Blob, any, string>;

readonly useGetGlobalSearchInteractions: (
  params: GetGlobalSearchInteractionsParams,
  enabled: boolean
) => UseQueryResult<any, any>;

readonly useGetShareUrl: (
  params:GetActiveUsersParams,
  enabled: boolean
) => UseQueryResult<any, any>;

readonly usePostShareUrl: () => UseMutationResult<
  any,
  unknown,
  GetActiveUsersParams
>;
readonly usePostAdhocInteractionBot: () => UseMutationResult<
  any,
  unknown,
  PostAdhocInteractionBotParams
>;

readonly useGetFrameworkStages: (
  enabled: boolean
) => UseQueryResult<any, any>;

readonly usePostGenerateTemplateBasedExtraction: () =>UseMutationResult<
  any,
  unknown,
  PostGenerateTemplateBasedExtractionParams
>;

readonly useGetGenerateTemplateBasedExtraction: (
  params: GetGenerateTemplateBasedExtractionParams,
  enabled: boolean
) => UseQueryResult<any, any>; 

readonly useShareInteractionViaEmail: () => UseMutationResult<
  any, 
  unknown, 
  GetShareInteractionViaEmailParams
>;

readonly usePostAssetAnalyze: () => UseMutationResult<
  any,
  unknown,
  PostAssetAnalyzeParams
>;

readonly useGetActiveOpportunities: (
  enabled: boolean,
  params?: GetActiveOpportunitiesParams
) => UseQueryResult<any, any>;
}

const UserInteractionsService: UserInteractionsService = Object.freeze({
  useGetUserInteractions,
  useGetInteractionDetails,
  useGetConversationInsights,
  useGetActiveUsers,
  useGetSharedUsers,
  usePostSharedInteractions,
  usePostRevokeInteractionAccess,
  useGetInteractionSlides,
  useGetInteractionNotes,
  useGetUserInteractionCount,
  useGetAbstractiveInsights,
  useDownloadWbrReport,
  useGetGlobalSearchInteractions,
  useGetShareUrl,
  usePostShareUrl,
  usePostAdhocInteractionBot,
  useGetFrameworkStages,
  usePostGenerateTemplateBasedExtraction,
  useGetGenerateTemplateBasedExtraction,
  useShareInteractionViaEmail,
  usePostAssetAnalyze,
  useGetActiveOpportunities,
});

export default UserInteractionsService;
